import React, { useEffect, useState } from "react";
import { useSdkContext } from "~/components/contexts";
import { useFallbackStorageValue } from "~/lib/hooks";
import { unionArray, useControlledPromise } from "~/lib/utils";
import { PianoTooltipDisplay } from "./component";
export const usePianoTooltipRender = () => {
  var _rosettaInstance$rule;
  const {
    rosettaInstance
  } = useSdkContext();
  const {
    set: setPianoTooltipHistory,
    value: pianoTooltipHistory
  } = useFallbackStorageValue("pianoTooltipHistory", {
    defaultValue: []
  });
  const {
    message,
    shortKey,
    version
  } = (_rosettaInstance$rule = rosettaInstance === null || rosettaInstance === void 0 ? void 0 : rosettaInstance.rulesEngine.getOutcome("ui.tooltip.messageObject")) !== null && _rosettaInstance$rule !== void 0 ? _rosettaInstance$rule : {};
  const tooltipKey = shortKey && version && `${shortKey}_${version.toString()}`;
  const [isNeedToShowRosettaTooltip, setIsNeedToShowRosettaTooltip] = useState();
  const {
    promise,
    reject,
    resolve
  } = useControlledPromise();
  useEffect(() => {
    if (!rosettaInstance) return;else if (tooltipKey && pianoTooltipHistory) {
      setIsNeedToShowRosettaTooltip(!pianoTooltipHistory.includes(tooltipKey));
      return;
    }
    setIsNeedToShowRosettaTooltip(false);
  }, [pianoTooltipHistory, rosettaInstance, tooltipKey, version]);
  useEffect(() => {
    if (!rosettaInstance || isNeedToShowRosettaTooltip === undefined) return;else if (isNeedToShowRosettaTooltip && message && tooltipKey) return resolve.current({
      node: /*#__PURE__*/React.createElement(PianoTooltipDisplay, {
        message: message
      }),
      onClose: () => {
        setPianoTooltipHistory(pianoHistory => unionArray(pianoHistory !== null && pianoHistory !== void 0 ? pianoHistory : [], [tooltipKey]));
        setIsNeedToShowRosettaTooltip(false);
      }
    });
    return reject.current();
  }, [isNeedToShowRosettaTooltip, message, reject, resolve, rosettaInstance, setPianoTooltipHistory, tooltipKey]);
  return {
    pianoTooltipRender: promise
  };
};